const NebulaBackground = () => {
  return (
    <div
      aria-hidden="true"
      role="presentation"
      className="absolute inset-0 pointer-events-none overflow-hidden"
      style={{
        background:
          'radial-gradient(ellipse at 50% 20%, hsl(262 60% 14%) 0%, hsl(249 55% 7%) 45%, hsl(249 60% 4%) 100%)',
        zIndex: 0,
      }}
    >
      {/* Magenta nebula bloom — top left */}
      <div
        className="absolute -top-40 -left-40 w-[900px] h-[900px] opacity-55 nebula-drift-1"
        style={{
          background:
            'radial-gradient(circle, hsl(322 95% 55% / 0.55) 0%, hsl(322 80% 45% / 0.3) 25%, hsl(285 70% 40% / 0.15) 50%, transparent 72%)',
          filter: 'blur(70px)',
          mixBlendMode: 'screen',
        }}
      />

      {/* Hot pink bloom — bottom right */}
      <div
        className="absolute -bottom-48 -right-32 w-[1000px] h-[1000px] opacity-50 nebula-drift-2"
        style={{
          background:
            'radial-gradient(circle, hsl(330 95% 60% / 0.5) 0%, hsl(322 85% 50% / 0.28) 30%, transparent 70%)',
          filter: 'blur(80px)',
          mixBlendMode: 'screen',
        }}
      />

      {/* Violet bloom — center mid */}
      <div
        className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[800px] h-[800px] opacity-40 nebula-drift-3"
        style={{
          background:
            'radial-gradient(circle, hsl(262 85% 60% / 0.45) 0%, hsl(275 70% 45% / 0.2) 40%, transparent 72%)',
          filter: 'blur(90px)',
          mixBlendMode: 'screen',
        }}
      />

      {/* Deep purple wash — far back */}
      <div
        className="absolute inset-0 opacity-60"
        style={{
          background:
            'radial-gradient(ellipse at 70% 80%, hsl(280 60% 18% / 0.55) 0%, transparent 60%)',
        }}
      />

      {/* Pink filament streak — diagonal */}
      <svg
        className="absolute inset-0 w-full h-full opacity-30"
        viewBox="0 0 1200 800"
        preserveAspectRatio="xMidYMid slice"
        style={{ mixBlendMode: 'screen' }}
      >
        <defs>
          <linearGradient id="filament1" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="hsl(322 100% 70%)" stopOpacity="0" />
            <stop offset="50%" stopColor="hsl(322 100% 70%)" stopOpacity="0.7" />
            <stop offset="100%" stopColor="hsl(262 90% 70%)" stopOpacity="0" />
          </linearGradient>
          <linearGradient id="filament2" x1="0%" y1="100%" x2="100%" y2="0%">
            <stop offset="0%" stopColor="hsl(330 100% 75%)" stopOpacity="0" />
            <stop offset="50%" stopColor="hsl(330 100% 75%)" stopOpacity="0.5" />
            <stop offset="100%" stopColor="hsl(280 90% 65%)" stopOpacity="0" />
          </linearGradient>
        </defs>
        <path
          d="M -100 600 Q 300 200, 700 400 T 1300 150"
          stroke="url(#filament1)"
          strokeWidth="2"
          fill="none"
          style={{ filter: 'blur(2px)' }}
        />
        <path
          d="M -100 200 Q 400 700, 800 350 T 1300 600"
          stroke="url(#filament2)"
          strokeWidth="1.5"
          fill="none"
          style={{ filter: 'blur(2px)' }}
        />
      </svg>

      {/* Subtle grain to kill banding */}
      <div
        className="absolute inset-0 opacity-[0.07] mix-blend-overlay"
        style={{
          backgroundImage:
            'url("data:image/svg+xml;utf8,<svg xmlns=\'http://www.w3.org/2000/svg\' width=\'140\' height=\'140\'><filter id=\'n\'><feTurbulence type=\'fractalNoise\' baseFrequency=\'0.9\' numOctaves=\'2\' stitchTiles=\'stitch\'/><feColorMatrix values=\'0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0\'/></filter><rect width=\'100%\' height=\'100%\' filter=\'url(%23n)\'/></svg>")',
        }}
      />

      <style>{`
        @keyframes nebula-drift-1 {
          0%, 100% { transform: translate(0, 0) scale(1); }
          50% { transform: translate(40px, 30px) scale(1.05); }
        }
        @keyframes nebula-drift-2 {
          0%, 100% { transform: translate(0, 0) scale(1); }
          50% { transform: translate(-50px, -20px) scale(1.08); }
        }
        @keyframes nebula-drift-3 {
          0%, 100% { transform: translate(-50%, 0) scale(1); }
          50% { transform: translate(calc(-50% + 30px), -25px) scale(1.04); }
        }
        .nebula-drift-1 { animation: nebula-drift-1 50s ease-in-out infinite; }
        .nebula-drift-2 { animation: nebula-drift-2 60s ease-in-out infinite; }
        .nebula-drift-3 { animation: nebula-drift-3 55s ease-in-out infinite; }
        @media (prefers-reduced-motion: reduce) {
          .nebula-drift-1, .nebula-drift-2, .nebula-drift-3 { animation: none; }
        }
      `}</style>
    </div>
  );
};

export default NebulaBackground;
